import request from '../axios';

export const invitePatient = (
  therapist_id: number,
  name: string,
  lastname: string,
  email: string,
  type: number
) =>
  request.post('/api/patient/invite', {
    therapist_id,
    name,
    lastname,
    email,
    type,
  });

export const getAllPatientsByTherapist = (therapist_id: number) =>
  request.get(`/api/patient/therapist/${therapist_id}`);

export const getPatient = (patient_id: string) =>
  request.get(`/api/patient/${patient_id}`);
export const updatePatientInfo = (patient_id: string, data: any) =>
  request.put(`/api/patient/${patient_id}`, { data });
export const sendPatientQuest = (
  patient_id: string,
  therapist_id: string,
  questionnaries: any
) =>
  request.post(`/api/patient/${patient_id}/questionnaires`, {
    therapist_id,
    questionnaries,
  });

export const getPatientAutoregistry = (
  patient_id: string,
  from: string,
  to: string
) =>
  request.get(`/api/patient/${patient_id}/autoregistry?from=${from}&to=${to}`);
export const sendPatientAutoregistry = (
  patient_id: string,
  therapist_id: string,
  name: string,
  questions: string[]
) =>
  request.post(`/api/patient/${patient_id}/autoregistry`, {
    therapist_id,
    name,
    questions,
  });
export const getAutoregistryMonthDots = (
  patient_id: string,
  from: string,
  to: string
) =>
  request.get(
    `/api/patient/${patient_id}/autoregistry/calendar?from=${from}&to=${to}`
  );
export const getDiaryMonthDots = (
  patient_id: string,
  from: string,
  to: string
) =>
  request.get(
    `/api/patient/${patient_id}/diary/calendar?from=${from}&to=${to}`
  );
export const getPatientDairies = (
  patient_id: string,
  from: string,
  to: string
) => request.get(`/api/patient/${patient_id}/diary?from=${from}&to=${to}`);
export const getPatientEmotionalTrack = (
  patient_id: string,
  from: string,
  to: string
) => request.get(`/api/patient/${patient_id}/emotional?from=${from}&to=${to}`);
export const sendNote = (patient_id: string, data: FormData) =>
  request.post(`/api/patient/${patient_id}/notes`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
export const getNotes = (patient_id: string) =>
  request.get(`/api/patient/${patient_id}/notes`);
export const startTranscription = (audio_id: string) =>
  request.get(`/api/audio/${audio_id}/transcriptions`);

export const getChangesHistory = (patient_id: string) =>
  request.get(`/api/patient/${patient_id}/changes-history`);
export const sendChangeHistory = (
  patient_id: string,
  title: string,
  description: string
) =>
  request.post(`/api/patient/${patient_id}/changes-history`, {
    title,
    description,
  });

export const getInformedConsent = (patient_id: string) =>
  request.get(`/api/patient/${patient_id}/informed-consent`);
export const getOtherDocumentation = (patient_id: string) =>
  request.get(`/api/patient/${patient_id}/documentation`);
export const deleteDocumentation = (patient_id: string, path: string) =>
  request.post(`/api/patient/${patient_id}/documentation/delete`, { path });

export const sendResource = (patient_id: string, data: FormData) =>
  request.post(`/api/patient/${patient_id}/resources`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
export const removeResource = (
  patient_id: string,
  path: string,
  type: string
) =>
  request.post(`/api/patient/${patient_id}/resources/delete`, { path, type });
export const assignResourceToPatient = (patient_id: string, resources: any[]) =>
  request.post(`/api/patient/${patient_id}/resources/assign`, { resources });
